require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./insights-achieving-gender-diversity.json") })
        }
      }, "path---insights-achieving-gender-diversity");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---insights-achieving-gender-diversity!./.cache/json/insights-achieving-gender-diversity.json
// module id = 1082
// module chunks = 231608221292675